import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' }, ,
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    starttime: {
      validations: []
    },
    plannedguestcount: {
      validations: []
    },
    eventextra1: {
      validations: []
    },
    theme: {
      validations: []
    },
    eventextra2: {
      validations: [
        { type: 'required', message: 'Please provide a date' },
      ]
    },
    notes: {
      validations: [
        { type: 'required', message: 'Please provide additional details' },
      ]
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'SCHEDULE A CELEBRATION',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name *',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name *',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email *',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number *',
            mapping: 'telNumber'
          },
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Requested Date',
            mapping: 'eventDate'
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Requested Time',
            options: [
              { label: '6:00 AM'  , value: '06:00:00'},
              { label: '6:30 AM'  , value: '06:30:00'},
              { label: '7:00 AM'  , value: '07:00:00'},
              { label: '7:30 AM'  , value: '07:30:00'},
              { label: '8:00 AM'  , value: '08:00:00'},
              { label: '8:30 AM'  , value: '08:30:00'},
              { label: '9:00 AM'  , value: '09:00:00'},
              { label: '9:30 AM'  , value: '09:30:00'},
              { label: '10:00 AM' , value: '10:00:00'},
              { label: '10:30 AM' , value: '10:30:00'},
              { label: '11:00 AM' , value: '11:00:00'},
              { label: '11:30 AM' , value: '11:30:00'},
              { label: '12:00 PM' , value: '12:00:00'},
              { label: '12:30 PM' , value: '12:30:00'},
              { label: '1:00 PM'  , value: '13:00:00'},
              { label: '1:30 PM'  , value: '13:30:00'},
              { label: '2:00 PM'  , value: '14:00:00'},
              { label: '2:30 PM'  , value: '14:30:00'},
              { label: '3:00 PM'  , value: '15:00:00'},
              { label: '3:30 PM'  , value: '15:30:00'},
              { label: '4:00 PM'  , value: '16:00:00'},
              { label: '4:30 PM'  , value: '16:30:00'},
              { label: '5:00 PM'  , value: '17:00:00'},
              { label: '5:30 PM'  , value: '17:30:00'},
              { label: '6:00 PM'  , value: '18:00:00'},
              { label: '6:30 PM'  , value: '18:30:00'},
              { label: '7:00 PM'  , value: '19:00:00'},
              { label: '7:30 PM'  , value: '19:30:00'},
              { label: '8:00 PM'  , value: '20:00:00'},
              { label: '8:30 PM'  , value: '20:30:00'},
              { label: '9:00 PM'  , value: '21:00:00'},
              { label: '9:30 PM'  , value: '21:30:00'},
              { label: '10:00 PM' , value: '22:00:00'},
              { label: '10:30 PM' , value: '22:30:00'},
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
              { label: '12:00 AM', value: '00:00:00' },
              { label: '12:30 AM', value: '00:30:00' },
              { label: '1:00 AM', value: '01:00:00' },
              { label: '1:30 AM', value: '01:30:00' },
              { label: '2:00 AM', value: '02:00:00' },
            ],
            mapping: 'starttime'
          },
          ]
      },
       {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Approximate number of guests',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Budget',
            mapping: 'eventextra1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Services',
            options: [
              { label: 'Participatory Dining Experience', value: 'Participatory Dining Experience' },
              { label: 'Wedding', value: 'Wedding' },
              { label: 'Birthday Packages', value: 'Birthday Packages' },
              { label: 'Corporate Event', value: 'Corporate Event' },
              { label: 'Rehearsal Dinner', value: 'Rehearsal Dinner' },
              { label: 'Bridal/Baby Shower', value: 'Bridal/Baby Shower' },
              { label: 'Catering', value: 'Catering' },
              { label: 'Other', value: 'Other' },
            ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Birthday *',
            mapping: 'eventextra2'
          }
        ]
          },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Message *',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SEND'
          }
        ]
      }
    ]
  },
  info: {
    title: 'The Kitchen Contact Form',
    formId: '610',
    clientKey: '304CA9BD-F9B5-4263-B210-555606971895',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/thekitchen/form_structure.js